<template>
  <div
    class="share-overlay"
  >
    <button
      class="preview-modal-button"
      @click="close"
    >
      <svg
        width="20px"
        height="20px"
        viewBox="0 0 30 30"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <defs />
        <g
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g
            transform="translate(-1530.000000, -40.000000)"
            fill="#FFFFFF"
          >
            <path
              d="M1545.8,54.2 L1564.20098,54.2 C1564.64227,54.2 1565,54.5550919 1565,55 C1565,55.4418278 1564.64198,55.8 1564.20098,55.8 L1545.8,55.8 L1545.8,74.2009848 C1545.8,74.6422687 1545.44491,75 1545,75 C1544.55817,75 1544.2,74.6419794 1544.2,74.2009848 L1544.2,55.8 L1525.79902,55.8 C1525.35773,55.8 1525,55.4449081 1525,55 C1525,54.5581722 1525.35802,54.2 1525.79902,54.2 L1544.2,54.2 L1544.2,35.7990152 C1544.2,35.3577313 1544.55509,35 1545,35 C1545.44183,35 1545.8,35.3580206 1545.8,35.7990152 L1545.8,54.2 Z"
              transform="translate(1545.000000, 55.000000) rotate(-315.000000) translate(-1545.000000, -55.000000) "
            />
          </g>
        </g>
      </svg>
    </button>
    <div class="middle">
      <div class="inner">
        <slot name="share-overlay-content" />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'share-overlay',
  props: {
    url: String
  },
  emits: ['close'],
  methods: {
    close(event) {
      event.stopPropagation()
      this.$emit('close')
    }
  }
}
</script>
